module.exports = __webpack_public_path__ + "img/bars.3e4045f3.webp";